import { inject, Pipe, PipeTransform } from '@angular/core';
import { AddinConfigService } from '@outlook-addin/shared';

@Pipe({
  name: 'resourceExternalUrl',
  standalone: true,
})
export class ResourceExternalUrlPipe implements PipeTransform {
  configService = inject(AddinConfigService);

  transform(resourceGuid: string, startDate: string, endDate: string): string {
    if (resourceGuid) {
      if (startDate && endDate) {
        return `${this.configService.value.configuration.assistURL}/reservations/reserve/${resourceGuid}/?startHint=${startDate}&endHint=${endDate}&tab=1`;
      }
      return `${this.configService.value.configuration.assistURL}/reservations/reserve/${resourceGuid}`;
    }
    return null;
  }
}
